import { defineRecipe } from '@chakra-ui/react';

export const badge = defineRecipe({
  className: 'chakra-badge',

  variants: {
    variant: {
      subtle: {
        bg: 'colorPalette.100',
        color: 'colorPalette.700',
        _dark: {
          bg: 'gray.200',
          color: 'fg.muted',
          boxShadow: 'sm',
          border: 'none',
          borderRadius: 'md',
          paddingX: '3',
        },
      },
      rating: {
        _dark: {
          bg: 'colorPalette.100',
          color: 'colorPalette.700',
        },
      },
      status: {
        _dark: {
          bg: 'gray.100',
          color: 'fg.muted',
          boxShadow: 'none',
          border: 'none',
          borderRadius: 'md',
          paddingX: '3',
        },
      },
      outline: {
        bg: 'none',
        color: 'colorPalette.700',
        shadowColor: 'colorPalette.700',
      },
    },
  },
  defaultVariants: {
    variant: 'subtle',
  },
});
